import React from 'react'
import PropTypes from 'prop-types'
//assets
import avatar from '../assets/img/Avatar__img.svg'
import '../assets/css/Avatar.css'
//components
import Login from './Login'
//material
import { withStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import DialogActions from '@material-ui/core/DialogActions';
//store
import profile from '../store/profile';
//Router
import {Link} from 'react-router-dom';


const styles = theme => ({
  typography: {
    padding: theme.spacing.unit * 2,
    width: '217px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  paper: {
    width: '249px'
  }
});

class Avatar extends React.Component {
  state = {
   anchorEl: null,
   open: false,
 };

 handleClick = event => {
   const { currentTarget } = event;
   this.setState(state => ({
     anchorEl: currentTarget,
     open: !state.open,
   }));
 };

  render () {
    const { classes } = this.props;
    const { anchorEl, open } = this.state;
    const id = open ? 'simple-popper' : null;
    return(
      <div className="Avatar" onClick={this.handleClick}>
          <img src={avatar} alt='Avatar' width='50px' height='50px' className='Avatar__img' aria-describedby={id} variant="contained"/>
          <div className='Avatar__name' >{profile.alias}</div>
          <Popper id={id} open={open} anchorEl={anchorEl} transition>
            {({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={350}>
                <Paper className={classes.paper}>
                  <Typography className={classes.typography}>
                    帳號 : {profile.username} 
                  </Typography>
                  <DialogActions>
                    <Button color="primary">
                          <Link to='/logout'>登出</Link>
                    </Button>
                  </DialogActions>
                </Paper>
              </Fade>
            )}
          </Popper>
      </div>
    )
  }
}

Avatar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Avatar);



// WEBPACK FOOTER //
// ./src/components/Avatar.js